/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'
import type {
    DeleteAlbumsResponseDTO,
    DeleteRequestDeleteAlbumsFromTrashCanParams,
    DeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidParams,
    DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidParams,
    FileUUIDListDTO,
    GetRequestEmptyTrashCanParams,
    GetRequestTrashCanAlbumsParams,
    GetRequestTrashCanParams,
    HTTPValidationErrorDTO,
    JobUUIDListDTO,
    PostRequestEmptyTrashCanParams,
    TrashcanAlbumItemDTO,
    TrashcanFileItemDTO,
} from '../../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * this call will list all files in the trash can

 * @summary Get Trash Can Files
 */
export const getRequestTrashCan = (
    params: GetRequestTrashCanParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<TrashcanFileItemDTO[]>(
        { url: `/trash_can`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestTrashCanQueryKey = (params?: GetRequestTrashCanParams) => {
    return [`/trash_can`, ...(params ? [params] : [])] as const
}

export const getGetRequestTrashCanQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCan>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestTrashCanQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestTrashCan>>> = ({ signal }) =>
        getRequestTrashCan(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestTrashCan>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestTrashCanQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestTrashCan>>
>
export type GetRequestTrashCanQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestTrashCan<
    TData = Awaited<ReturnType<typeof getRequestTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCan>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestTrashCan>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestTrashCan>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestTrashCan<
    TData = Awaited<ReturnType<typeof getRequestTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCan>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestTrashCan>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestTrashCan>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestTrashCan<
    TData = Awaited<ReturnType<typeof getRequestTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCan>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Trash Can Files
 */

export function useGetRequestTrashCan<
    TData = Awaited<ReturnType<typeof getRequestTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCan>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestTrashCanQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * this call will list all albums in the trash can

 * @summary Get Trash Can Albums Endpoint
 */
export const getRequestTrashCanAlbums = (
    params: GetRequestTrashCanAlbumsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<TrashcanAlbumItemDTO[]>(
        { url: `/trash_can_albums`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestTrashCanAlbumsQueryKey = (params?: GetRequestTrashCanAlbumsParams) => {
    return [`/trash_can_albums`, ...(params ? [params] : [])] as const
}

export const getGetRequestTrashCanAlbumsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestTrashCanAlbums>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanAlbumsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCanAlbums>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestTrashCanAlbumsQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestTrashCanAlbums>>> = ({
        signal,
    }) => getRequestTrashCanAlbums(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestTrashCanAlbums>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestTrashCanAlbumsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestTrashCanAlbums>>
>
export type GetRequestTrashCanAlbumsQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestTrashCanAlbums<
    TData = Awaited<ReturnType<typeof getRequestTrashCanAlbums>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanAlbumsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCanAlbums>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestTrashCanAlbums>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestTrashCanAlbums>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestTrashCanAlbums<
    TData = Awaited<ReturnType<typeof getRequestTrashCanAlbums>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanAlbumsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCanAlbums>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestTrashCanAlbums>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestTrashCanAlbums>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestTrashCanAlbums<
    TData = Awaited<ReturnType<typeof getRequestTrashCanAlbums>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanAlbumsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCanAlbums>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Trash Can Albums Endpoint
 */

export function useGetRequestTrashCanAlbums<
    TData = Awaited<ReturnType<typeof getRequestTrashCanAlbums>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestTrashCanAlbumsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestTrashCanAlbums>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestTrashCanAlbumsQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * empty_trash_can for a given file

 * @summary Get Empty Trash Can
 */
export const getRequestEmptyTrashCan = (
    params: GetRequestEmptyTrashCanParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        { url: `/empty_trash_can`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestEmptyTrashCanQueryKey = (params?: GetRequestEmptyTrashCanParams) => {
    return [`/empty_trash_can`, ...(params ? [params] : [])] as const
}

export const getGetRequestEmptyTrashCanQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestEmptyTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestEmptyTrashCanParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestEmptyTrashCan>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestEmptyTrashCanQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestEmptyTrashCan>>> = ({
        signal,
    }) => getRequestEmptyTrashCan(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestEmptyTrashCan>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestEmptyTrashCanQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestEmptyTrashCan>>
>
export type GetRequestEmptyTrashCanQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestEmptyTrashCan<
    TData = Awaited<ReturnType<typeof getRequestEmptyTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestEmptyTrashCanParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestEmptyTrashCan>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestEmptyTrashCan>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestEmptyTrashCan>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestEmptyTrashCan<
    TData = Awaited<ReturnType<typeof getRequestEmptyTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestEmptyTrashCanParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestEmptyTrashCan>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestEmptyTrashCan>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestEmptyTrashCan>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestEmptyTrashCan<
    TData = Awaited<ReturnType<typeof getRequestEmptyTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestEmptyTrashCanParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestEmptyTrashCan>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Empty Trash Can
 */

export function useGetRequestEmptyTrashCan<
    TData = Awaited<ReturnType<typeof getRequestEmptyTrashCan>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestEmptyTrashCanParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestEmptyTrashCan>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestEmptyTrashCanQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * empty_trash_can for a given file

 * @summary Post Empty Trash Can
 */
export const postRequestEmptyTrashCan = (
    params: PostRequestEmptyTrashCanParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        { url: `/empty_trash_can`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestEmptyTrashCanMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestEmptyTrashCan>>,
        TError,
        { params: PostRequestEmptyTrashCanParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestEmptyTrashCan>>,
    TError,
    { params: PostRequestEmptyTrashCanParams },
    TContext
> => {
    const mutationKey = ['postRequestEmptyTrashCan']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestEmptyTrashCan>>,
        { params: PostRequestEmptyTrashCanParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestEmptyTrashCan(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestEmptyTrashCanMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestEmptyTrashCan>>
>

export type PostRequestEmptyTrashCanMutationError = ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Post Empty Trash Can
 */
export const usePostRequestEmptyTrashCan = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestEmptyTrashCan>>,
            TError,
            { params: PostRequestEmptyTrashCanParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestEmptyTrashCan>>,
    TError,
    { params: PostRequestEmptyTrashCanParams },
    TContext
> => {
    const mutationOptions = getPostRequestEmptyTrashCanMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call is used to permanently delete files from trash can.

 * @summary Delete Files From Trash Can
 */
export const deleteRequestJobsDeleteFilesFromTrashCanByJobUuid = (
    jobUuid: string,
    fileUUIDListDTO: BodyType<FileUUIDListDTO>,
    params: DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/delete_files_from_trash_can`,
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            data: fileUUIDListDTO,
            params,
        },
        options,
    )
}

export const getDeleteRequestJobsDeleteFilesFromTrashCanByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestJobsDeleteFilesFromTrashCanByJobUuid>>,
        TError,
        {
            jobUuid: string
            data: BodyType<FileUUIDListDTO>
            params: DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestJobsDeleteFilesFromTrashCanByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<FileUUIDListDTO>
        params: DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['deleteRequestJobsDeleteFilesFromTrashCanByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestJobsDeleteFilesFromTrashCanByJobUuid>>,
        {
            jobUuid: string
            data: BodyType<FileUUIDListDTO>
            params: DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, data, params } = props ?? {}

        return deleteRequestJobsDeleteFilesFromTrashCanByJobUuid(
            jobUuid,
            data,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestJobsDeleteFilesFromTrashCanByJobUuid>>
>
export type DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidMutationBody =
    BodyType<FileUUIDListDTO>
export type DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Files From Trash Can
 */
export const useDeleteRequestJobsDeleteFilesFromTrashCanByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestJobsDeleteFilesFromTrashCanByJobUuid>>,
            TError,
            {
                jobUuid: string
                data: BodyType<FileUUIDListDTO>
                params: DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestJobsDeleteFilesFromTrashCanByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<FileUUIDListDTO>
        params: DeleteRequestJobsDeleteFilesFromTrashCanByJobUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestJobsDeleteFilesFromTrashCanByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call is used to permanently delete album from trash can

 * @summary Delete Album From Trash Can Endpoint
 */
export const deleteRequestJobsDeleteAlbumFromTrashCanByJobUuid = (
    jobUuid: string,
    params: DeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/delete_album_from_trash_can`,
            method: 'DELETE',
            params,
        },
        options,
    )
}

export const getDeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestJobsDeleteAlbumFromTrashCanByJobUuid>>,
        TError,
        { jobUuid: string; params: DeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestJobsDeleteAlbumFromTrashCanByJobUuid>>,
    TError,
    { jobUuid: string; params: DeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidParams },
    TContext
> => {
    const mutationKey = ['deleteRequestJobsDeleteAlbumFromTrashCanByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestJobsDeleteAlbumFromTrashCanByJobUuid>>,
        { jobUuid: string; params: DeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return deleteRequestJobsDeleteAlbumFromTrashCanByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestJobsDeleteAlbumFromTrashCanByJobUuid>>
>

export type DeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Album From Trash Can Endpoint
 */
export const useDeleteRequestJobsDeleteAlbumFromTrashCanByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestJobsDeleteAlbumFromTrashCanByJobUuid>>,
            TError,
            { jobUuid: string; params: DeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestJobsDeleteAlbumFromTrashCanByJobUuid>>,
    TError,
    { jobUuid: string; params: DeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestJobsDeleteAlbumFromTrashCanByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call is used to permanently delete albums from trash can

 * @summary Delete Albums From Trash Can Endpoint
 */
export const deleteRequestDeleteAlbumsFromTrashCan = (
    jobUUIDListDTO: BodyType<JobUUIDListDTO>,
    params: DeleteRequestDeleteAlbumsFromTrashCanParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<DeleteAlbumsResponseDTO>(
        {
            url: `/delete_albums_from_trash_can`,
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            data: jobUUIDListDTO,
            params,
        },
        options,
    )
}

export const getDeleteRequestDeleteAlbumsFromTrashCanMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestDeleteAlbumsFromTrashCan>>,
        TError,
        { data: BodyType<JobUUIDListDTO>; params: DeleteRequestDeleteAlbumsFromTrashCanParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestDeleteAlbumsFromTrashCan>>,
    TError,
    { data: BodyType<JobUUIDListDTO>; params: DeleteRequestDeleteAlbumsFromTrashCanParams },
    TContext
> => {
    const mutationKey = ['deleteRequestDeleteAlbumsFromTrashCan']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestDeleteAlbumsFromTrashCan>>,
        { data: BodyType<JobUUIDListDTO>; params: DeleteRequestDeleteAlbumsFromTrashCanParams }
    > = (props) => {
        const { data, params } = props ?? {}

        return deleteRequestDeleteAlbumsFromTrashCan(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestDeleteAlbumsFromTrashCanMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestDeleteAlbumsFromTrashCan>>
>
export type DeleteRequestDeleteAlbumsFromTrashCanMutationBody = BodyType<JobUUIDListDTO>
export type DeleteRequestDeleteAlbumsFromTrashCanMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Albums From Trash Can Endpoint
 */
export const useDeleteRequestDeleteAlbumsFromTrashCan = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestDeleteAlbumsFromTrashCan>>,
            TError,
            { data: BodyType<JobUUIDListDTO>; params: DeleteRequestDeleteAlbumsFromTrashCanParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestDeleteAlbumsFromTrashCan>>,
    TError,
    { data: BodyType<JobUUIDListDTO>; params: DeleteRequestDeleteAlbumsFromTrashCanParams },
    TContext
> => {
    const mutationOptions = getDeleteRequestDeleteAlbumsFromTrashCanMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
